import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../../actions';
import { CONFIG } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import __ from 'lodash';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import LoaderModal from '../../../../modal/LoaderModal';
import Loader from '../../../../Loader';
import KelasParalelSearch from '../../../../../entity/KelasParalelSearch';
import KelasSearch from '../../../../../entity/KelasSearch';
import GuruKelasAdd from '../../../../../entity/GuruKelasAdd';
import { Card, Row, Col, Alert, Modal } from 'react-bootstrap';
import {List,ListItem,ListItemText,Collapse, Divider, Switch} from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

class GuruKelas extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            sekolah: {},            
            kelas: [],
            kelasParalel: [],
            objKelasParalel:{},
            allGuru:[],
            guruKelas: [],
            guruSelected:[],
            error: null,
            resMessage: {},
            isFetching: false,
            isLoadingK: false,
            isLoadingKp: false,
            message: '',
            showAlert: false,
            showModal: false,
        }
    }
    async componentDidMount(){
        document.title = "Guru Kelas";
        this.setState({isFetching: true});
        await this.props.cekCookies();
        this.setState({isFetching: false});
        if(!__.isEmpty(this.props.account)){            
            this.fetchKelas();  
            this.fetchGuru();         
        }
    }

    fetchKelas = async () =>{
        this.setState({isFetching: true});

        //fetch sekolah dulu
        const resSekolah = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_SEKOLAH + this.props.account.idSekolah).catch(function(error){
        })
        if(resSekolah){
            if(resSekolah.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    sekolah: resSekolah.data.data
                })
            }
        }

        //fetch kelas setelah dapat data sekolah
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS, {KelasSearch, ["kodeJenjangSekolah"]: this.state.sekolah.kodeJenjangSekolah}).catch(function(error){
        });        
        
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    kelas: response.data.data
                }) 
            }               
        }
        this.setState({isFetching: false});
    }

    getGuruKelas = async(id, open) => {        
        this.setState(state => ({
          ...state,
          kelasParalel: state.kelasParalel.map(item =>
            item.idKelasParalel === id ? { ...item, open: !open } : { ...item, open: false }
          )
        }));

        this.setState({showAlert:false, isLoadingKp: true,guruKelas: [] })
        if(!open) {
            const response = await accountManagement.get(CONFIG.GET_GURU_KELAS_BY_KP + id).catch(function(error){
            });        
                        
            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        guruKelas: response.data.data
                    }) 
                }  else {
                    this.setState({
                        message: response.data.errorSchema.errorMessage,
                        showAlert:true
                    })
                } 
                this.setState({ isLoadingKp: false })                   
            }
        }
      };

    getKelasP = async(idKelas, open) => {
        this.setState(state => ({
            ...state,
            kelas: state.kelas.map(item =>
              item.idKelas === idKelas ? { ...item, open: !open } : { ...item, open: false }
            )
        }));
  
        this.setState({showAlert:false, isLoadingK: true, kelasParalel: [] })  
        if(!open) {      
            const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_KELAS_PARALEL,
                {KelasParalelSearch,['idKelas']: idKelas, ['idSekolah']: this.props.account.idSekolah}).catch (function(error){
            })        
            
            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        kelasParalel: response.data.data                        
                    })
                }  else {
                    this.setState({
                        message: response.data.errorSchema.errorMessage,
                        showAlert:true
                    })
                } 
                this.setState({ isLoadingK: false })         
            }
        }
    }

    fetchGuru = async () =>{
        //fetch sekolah dulu
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_FETCH_GURU,{['idSekolah']:this.props.account.idSekolah}).catch(function(error){
        })

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    allGuru: response.data.data
                })
            }
        }
        
        // this.state.GuruEnt.map((x, i) => {  
        //     const result = Object.values(x);  
        //     this.XX.push(result); 
        //  })
    }

    loadAlert = () => {
        const {showAlert } = this.state;
      
        if (showAlert) {
          return (
            <Alert variant="info" onClose={() => this.setState({ showAlert: false })} dismissible>   
                <strong>{this.state.message}</strong>
            </Alert>
          );
        } 
    }

    handleChange(e) {        
        let isChecked = e.target.checked;
        let value = e.target.value;
        const { allGuru, guruSelected } = this.state;
        // do whatever you want with isChecked value         
        if(isChecked) {
            allGuru.map( item => {
                if (item.idGuru == value) {                    
                    this.setState(prevState => ({
                        guruSelected: [...prevState.guruSelected, item]
                      }));
                } 
            })
            
        } else {
            this.setState({ 
                guruSelected: guruSelected.filter(v => v.idGuru != value)
            });
        }                
    }

    handleModal(params) {     
        this.setState({
            showModal: true,
            objKelasParalel: params,
            guruSelected: this.state.guruKelas         
        })                
    }

    handleSubmit = async() => {        
        this.setState({isFetching: true, showModal: false});
        const {objKelasParalel, guruSelected} = this.state
        
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_ADD_GURU_KELAS, {...GuruKelasAdd,
            ["idKelas"]: objKelasParalel.idKelas,
            ["idKelasParalel"]: objKelasParalel.idKelasParalel,
            ["listGuru"]: guruSelected.map(val => val.idGuru)
        }).catch(function(error){
            this.setState({message: error});
        });        
        
        if(response) {
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    message: response.data.errorSchema.errorMessage, 
                    guruKelas: guruSelected                                    
                })                             
            } else {
                this.setState({
                    message: response.data.errorSchema.errorMessage
                })                
            }
            this.setState({isFetching: false, showAlert:true, guruSelected: [] }); 

        }
    }

    showModal(){ 
        const {showModal,allGuru,guruSelected,objKelasParalel} = this.state;  
        const sScroll = {
            maxHeight: '600px', overflow: 'auto'
        }
        const handleClose = () => this.setState({showModal: false});          
        return (
            <Modal show={showModal} size="lg" onHide={handleClose}>
                <Modal.Header closeButton>
                     <Modal.Title>Guru Kelas: {objKelasParalel.namaKelasParalel}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={sScroll}>                
                    <table className="table table-responsive table-bordered">
                    <thead>
                        <th width="8px">No.</th>
                        <th>Nama</th>
                        <th width="30px">No. HP</th>
                        <th>Email</th>
                        <th width="8px">#</th>
                    </thead>
                    <tbody>
                        {allGuru.map((guru,i) =>
                            <tr key={guru.idGuru}>
                                <td>{i+1}</td>
                                <td>{guru.namaGuru}</td>
                                <td>{guru.handphoneGuru}</td>
                                <td>{guru.emailGuru}</td>
                                <td><Switch color="secondary" value={guru.idGuru} 
                                    onChange={e => this.handleChange(e)}
                                    defaultChecked={ guruSelected.find(val => val.idGuru == guru.idGuru ? true : false)} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                    </table>                       
                                            
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={() => {if (window.confirm('Konfirmasi Simpan ?')) this.handleSubmit() }}>Simpan</button>
                </Modal.Footer>
            </Modal>
        )
    }

    render() { 
        const {isLoadingK, isLoadingKp,kelas, kelasParalel,guruKelas} = this.state;        
        return ( 
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar /> 
                    <h4>Management Guru Kelas</h4> 
                    {this.loadAlert()}
                    <List>
                      {kelas.map(k => 
                        <Card style={{marginBottom:'5px'}}>
                            <Card.Header>
                                <ListItem className="text-center" button onClick={() => this.getKelasP(k.idKelas, k.open)}>                                    
                                    <ListItemText inset primary={k.namaKelas} />      
                                    {k.open ? <span style={{fontSize:'24px', color:'DodgerBlue'}}><i class="fa fa-toggle-on" aria-hidden="true"></i> </span>
                                            : <span style={{fontSize:'24px', color:'DodgerBlue'}}><i class="fa fa-toggle-off" aria-hidden="true"></i></span>}                                          
                                </ListItem>
                            </Card.Header>
                            {k.open && isLoadingK ? <Loader /> :                             
                            <Collapse timeout="auto" unmountOnExit style={{margin: '0 20px'}}
                                in={kelas.find(item => item.idKelas === k.idKelas).open}>
                                <List>
                                {kelasParalel.map(kp => 
                                <div>
                                    <Row>
                                        <Col>
                                            <ListItem button onClick={() => this.getGuruKelas(kp.idKelasParalel, kp.open)}>
                                                {kp.open ? <ExpandMore /> : <ChevronRightIcon />}
                                                <ListItemText primary={kp.namaKelasParalel} />                                                
                                            </ListItem>
                                        </Col>
                                        
                                    </Row>
                                    {kp.open && isLoadingKp ? <Loader /> : 
                                    <Collapse timeout="auto" unmountOnExit style={{margin: '0 20px'}}
                                        in={kelasParalel.find(item => item.idKelasParalel === kp.idKelasParalel).open}>
                                        <List>
                                            <div className="text-right" style={{marginBottom:'5px'}}>                                                
                                                <button className="btn btn-outline-dark" onClick={() => this.handleModal( kp)}>Manage Guru</button>                                                
                                            </div> 
                                            {guruKelas.map(guru =>
                                                <Card border="info" style={{marginBottom:'5px'}}>
                                                    <Card.Body>
                                                        <Row>
                                                            <Col sm={4}>
                                                                <AccountCircleIcon /> {guru.namaGuru}
                                                            </Col>
                                                            <Col sm={2}>
                                                                {guru.handphoneGuru}
                                                            </Col>
                                                            <Col sm={4}>
                                                                {guru.emailGuru}
                                                            </Col>
                                                            <Col sm={2}>
                                                                {guru.statusGuru === "0" ? "Aktif" : "Non-Aktif"}
                                                            </Col>                                                            
                                                        </Row>                                                
                                                    </Card.Body>
                                                </Card>  
                                            )} 
                                        </List>
                                    </Collapse>
                                    }
                                    <Divider />
                                </div>                              
                                )}
                                </List>
                            </Collapse>
                            }
                            
                            
                        </Card>
                      )}                  
                    
                    </List>
                    {this.showModal()}
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}

export default connect(mapStateToProps, {cekCookies})(GuruKelas);
